import {
    UPDATE_ACCOUNT,
    UPDATE_ACCOUNT_FAILURE,
    UPDATE_ACCOUNT_SUCCESS,
} from 'store/actions/types';

export const updateAccount = (payload) => {
    return {
        type: UPDATE_ACCOUNT,
        payload: payload,
    };
};

export const updateAccountFailure = (error) => {
    return {
        type: UPDATE_ACCOUNT_FAILURE,
        payload: error,
    };
};

export const updateAccountSuccess = (response) => {
    return {
        type: UPDATE_ACCOUNT_SUCCESS,
        payload: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/accounts/updateAccounts.js